import ConstructionReportAuthoringPage from "./pages/ConstructionReportAuthoringPage";
import "./styles/constructionReportAuthoring.scss";

export default function ConstructionReportAuthoring() {
  return (
    <div className="constructionReportAuthoring">
      <ConstructionReportAuthoringPage />
    </div>
  );
}
